import React from 'react'

const HorizontalLine = () => {
  return (
    <div className={`tw-box-border tw-w-auto tw-border-t-[1px] tw-border-solid tw-border-lightgray-200`} />
  )
}

export default HorizontalLine